import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { ThemeProvider } from '@material-ui/core/styles';
import Theme from '../theme/CustomTheme'
import "../styles/MuiCustom.css"
import NavBar from './NavBar'
import NumberFormat from 'react-number-format';
import { FormControl, FormHelperText } from '@material-ui/core';
import axios from 'axios';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css'
import Copyright from './Copyright'

const useStyles = makeStyles(theme => ({
    root: {
        maxWidth: 350,
        margin: "150px auto 50px auto",
        height: 350
    },
    button: {
        "&:hover": {
            color: "#fff",
            backgroundColor: "#303030"
        }
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

export default function OutlinedCard(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [show, setShow] = React.useState(false);
    const [alertMsg, setAlertMsg] = React.useState("")
    const [phoneNo, setPhoneNo] = React.useState("");
    const [error, setError] = React.useState({
        phone: {
            isEmpty: false,
            invalid: false
        },
    })

    let rePhone = /^(?:\+?88)?01[3-9]\d{8}$/
    const msg = "This is a required field";

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        setError({
            phone: {
                isEmpty: false,
                invalid: false
            }
        });
        setPhoneNo(e);
    }

    const handleSubmit = () => {
        if (!phoneNo) {
            setError({
                phone: {
                    isEmpty: true
                }
            });
        } else if (!rePhone.test(phoneNo)) {
            setError({
                ...error,
                phone: {
                    invalid: true
                }
            });
        } else {
            if (localStorage.getItem('token') === null) {
                axios({
                    method: 'post',
                    url: process.env.REACT_APP_REG_API_BASE + '/jwt_sign',
                }).then(res => {
                    localStorage.setItem("token", JSON.stringify(res.data.token))
                    driverInfo();
                })
            } else {
                driverInfo();
            }
        }
    }

    const driverInfo = () => {
        axios({
            method: 'post',
            url: process.env.REACT_APP_REG_API_BASE + "/driver_info",
            headers: {
                'Authorization': JSON.parse(localStorage.getItem('token'))
            },
            data: {
                "driver_phone": phoneNo
            }
        }).then(res => {
            if (res.data.status === 201) {
                localStorage.removeItem('token')
                setShow(true)
                setAlertMsg(res.data.message)
            } else {
                localStorage.setItem("user_id", JSON.stringify(res.data.data[0].user_id))
                localStorage.setItem("user_name", JSON.stringify(res.data.data[0].user_name))
                localStorage.setItem("admin_id", JSON.stringify(res.data.data[0].admin_id))
                localStorage.setItem("phone_no", JSON.stringify(res.data.data[0].phone_no))
                localStorage.setItem("present_district", JSON.stringify(res.data.data[0].present_district))
                localStorage.setItem("present_post_office", JSON.stringify(res.data.data[0].present_police_station))
                props.history.push("/add-vehicle")
            }
        }).catch(err => {
            localStorage.removeItem('token')
            setShow(true)
            setAlertMsg("Something went wrong!")
        })
    }

    const newDriver = () => {
        if (localStorage.getItem('token') === null) {
            axios({
                method: 'post',
                url: process.env.REACT_APP_REG_API_BASE + '/jwt_sign',
            }).then(res => {
                localStorage.setItem("token", JSON.stringify(res.data.token))
                props.history.push('/rider-registration')
            }).catch(err => {
                setShow(true)
                setAlertMsg("Something went wrong!")
            })
        } else {
            props.history.push('/rider-registration')
        }
    }

    return (
        <React.Fragment>
            <NavBar showMenu={false} title="Driver Registration" />
            <ThemeProvider theme={Theme}>
                <Card className={`${classes.root} elevation`}>
                    <div style={{
                        marginTop: 70
                    }}>
                        <CardContent>
                            <div className={classes.buttons} style={{ textAlign: "center" }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    style={{
                                        width: "100%",
                                        padding: "10px 0",
                                        fontSize: 20,
                                    }}
                                    onClick={newDriver}
                                >New Driver
                                </Button>
                            </div>
                        </CardContent>
                        <CardContent>
                            <div className={classes.buttons} style={{ textAlign: "center" }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    style={{
                                        width: "100%",
                                        padding: "10px 0",
                                        fontSize: 20
                                    }}
                                    onClick={handleOpen}
                                >Existing Driver</Button>
                                <Modal
                                    aria-labelledby="transition-modal-title"
                                    aria-describedby="transition-modal-description"
                                    className={classes.modal}
                                    open={open}
                                    onClose={handleClose}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >
                                    <Fade in={open}>
                                        <div className={classes.paper}>
                                            <h2 id="transition-modal-title">Enter Registered Phone Number</h2>
                                            <FormControl style={{
                                                width: "100%",
                                                marginBottom: 20
                                            }} required error={error.phone.isEmpty || error.phone.invalid}>
                                                <NumberFormat
                                                    error={error.phone.isEmpty || error.phone.invalid}
                                                    name="phone"
                                                    variant="outlined"
                                                    placeholder="Phone Number"
                                                    customInput={TextField}
                                                    format="+88###########"

                                                    value={phoneNo}
                                                    onValueChange={(values) => {
                                                        handleChange(values.formattedValue)
                                                    }}
                                                />
                                                {
                                                    error.phone.isEmpty ?
                                                        <FormHelperText>
                                                            {msg}
                                                        </FormHelperText> : "" || error.phone.invalid ? <FormHelperText>Invalid phone number</FormHelperText> : ""
                                                }
                                            </FormControl>
                                            <div style={{ textAlign: "center" }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    onClick={handleSubmit}
                                                >
                                                    Submit
                                            </Button>
                                            </div>
                                        </div>
                                    </Fade>
                                </Modal>
                            </div>
                        </CardContent>
                    </div>
                </Card>
                <Copyright />
                <SweetAlert
                    show={show}
                    type="error"
                    title={alertMsg}
                    text="Please enter registered phone number"
                    onConfirm={() => {
                        setShow(false)
                    }}
                />
            </ThemeProvider>
        </React.Fragment>
    );
}